export const LOADER_EMPLOYEE_MONITOR         =       'LOADER_EMPLOYEE_MONITOR';
export const GET_EMPLOYEE_MONITOR            =       'GET_EMPLOYEE_MONITOR';
export const EMPLOYEE_MONITOR_FALLA          =       'EMPLOYEE_MONITOR_FALLA';
export const SAVE_LOADER_EMPLOYEE_MONITOR    =       'SAVE_LOADER_EMPLOYEE_MONITOR';
export const FORM_EMPLOYEE_MONITOR_FAIL      =       'FORM_EMPLOYEE_MONITOR_FAIL';
